module.exports = __webpack_public_path__ + "img/44f4b6f.jpg";